// @flow
import React from 'react';

import { CardHeader } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';

import { UNAVAILABILITY_REASON_DESCRIPTIONS } from 'utils/results';

import {
  red100,
  red600,
  red800,
  green100,
  green600,
  green800,
  amber100,
  amber600,
  amber800,
} from 'material-ui/styles/colors';
import { isFeatureDisabled } from '../../utils/auth';

const getAvailabilityState = ({ available, onPaneSelected }) => {
  if (isFeatureDisabled('airspace_availability'))
    return {
      titleText: 'Eseti légtér igénylése',
      subtitleText: '',
      iconColor: green100,
      iconText: '',
    };

  if (available === 'AVAILABLE') {
    return {
      titleText: 'Az eseti légtér igényelhető',
      subtitleText: isFeatureDisabled('documents') ? '' : (
        <span>
          Az igényléshez szükséges dokumentumokat a
          <span
            style={{
              display: 'inline-block',
              margin: '0 4px',
              padding: 4,
              borderRadius: 2,
              border: `1px solid ${green600}`,
              cursor: 'pointer',
            }}
            onClick={() => onPaneSelected(1, 'obtainables')}
          >
            <FontIcon
              className="material-icons"
              size={16}
              color={green600}
              style={{ verticalAlign: 'middle' }}
            >
              description
            </FontIcon>Dokumentumok
          </span>
          fülön találja.
        </span>
      ),
      iconColor: green800,
      iconText: 'check',
    };
  } else if (available === 'WARNING') {
    return {
      titleText: 'Az eseti légtér valószínűleg nem igényelhető',
      subtitleText: 'Az igényelt légtér átfed egy már beadott igényléssel.',
      iconColor: amber800,
      iconText: 'warning',
    };
  }
  return {
    titleText: 'Az eseti légtér nem igényelhető',
    subtitleText: '',
    iconColor: red800,
    iconText: 'error',
  };
};

const getStyles = ({ isMobile, available }) => {
  let headerBackground, titleColor, subtitleColor;

  switch (available) {
    case 'AVAILABLE':
      headerBackground = green100;
      titleColor = green800;
      subtitleColor = green600;
      break;

    case 'WARNING':
      headerBackground = amber100;
      titleColor = amber800;
      subtitleColor = amber600;
      break;

    default:
      headerBackground = red100;
      titleColor = red800;
      subtitleColor = red600;
      break;
  }

  return {
    card: {
      borderRadius: 2,
      boxShadow: 'none',
    },

    header: {
      position: isMobile ? 'static' : 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 9,
      background: headerBackground,
      borderRadius: 2,

      overflow: 'hidden',
    },

    title: {
      color: titleColor,
      fontSize: 18,
      paddingTop: 10,
      paddingBottom: 6,
    },

    subtitle: {
      color: subtitleColor,
    },

    unavReasonList: {
      margin: 0,
      marginLeft: 24,
      padding: 0,
    },
  };
};

const renderSubtitle = (
  { available, reasons, has_contact_info },
  availabilityState,
  styles
) => {
  if (available === 'UNAVAILABLE') {
    return (
      <ul
        style={{
          ...styles.unavReasonList,
          ...(reasons.length === 1
            ? {
                listStyle: 'none',
                marginLeft: 0,
              }
            : {}),
        }}
      >
        {reasons.map(r => <li>{UNAVAILABILITY_REASON_DESCRIPTIONS[r]}</li>)}
      </ul>
    );
  } else if (available === 'AVAILABLE' && has_contact_info === true) {
    // Hide the message about documents if the user got here
    // from selecting the "Details" button in the prop sheet
    // b/c in that case documents are already in the selected tab.
    return null;
  }

  return availabilityState.subtitleText;
};

export default ({
  browser,
  search: { has_contact_info, availability_result: result },

  onPaneSelected,
}) => {
  if (!result) {
    return null;
  }

  const isMobile = browser.lessThan.medium;
  const styles = getStyles({ ...result, isMobile });
  const availabilityState = getAvailabilityState({
    available: result.available,
    onPaneSelected,
  });

  return (
    <CardHeader
      style={styles.header}
      titleStyle={styles.title}
      subtitleStyle={styles.subtitle}
      title={availabilityState.titleText}
      subtitle={renderSubtitle(
        { ...result, has_contact_info },
        availabilityState,
        styles
      )}
      avatar={
        <Avatar
          icon={
            <FontIcon className="material-icons">
              {availabilityState.iconText}
            </FontIcon>
          }
          color="white"
          backgroundColor={availabilityState.iconColor}
        />
      }
    />
  );
};



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/Header.js